@if (loading) {
  <div class="page-loading">
    <span><span></span></span>
  </div>
}
<div>
  <div>
    <h1><span class="fa fa-calendar"></span> My Branch</h1>
  </div>
  @if (!loading) {
    @if (failed) {
      <div class="small-12 columns" role="alert">
        <p>We couldn't load your branch events. Please try again.</p>
        <button type="button" (click)="loadEvents()">Try again</button>
      </div>
    } @else if (listings.length === 0) {
      <div class="small-12 columns">
        <p>There are no upcoming events for your branch.</p>
      </div>
    } @else {
      <div>
        <product-list [items]="listings"></product-list>
      </div>
    }
  }
</div>
